import React from 'react'
import DatesTable from './components/DateTable/DatesTable'
import Title from '../../../components/Title/Title'
import { importantDates2027 } from '../../../common/constants/importantDates'

const ImportantDates2027page = () => {
    return (
        <>
            <Title>Important Dates</Title>
            <DatesTable array={importantDates2027} />
        </>
    )
}

export default ImportantDates2027page;
